<template>
  <div class="intelligent-container">
    <VerticalBanner
      :lists="carouselImgs"
      :indicatorPosition="'none'"
      :height="'640px'"
      :isShowMore="true"
    />
    <div class="module whiteBg blurb">
      <div class="box" v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }">
        <div class="blurb-title">
          {{ blurb.title }}
        </div>
        <div class="blurb-desc text-wrap">{{ blurb.description }}</div>
        <img class="c_img" :src="blurb.img[0].url" alt="" srcset="" />
      </div>
    </div>
    <div class="module greyBg">
      <div class="box">
        <div
          class="product jgpt"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <div class="content">
            <div class="title">{{ jgpt.title }}</div>
            <div class="subTitle">{{ jgpt.subTitle }}</div>
            <div class="desc text-wrap">{{ jgpt.description }}</div>
            <button
              class="know-more-btn"
              @click="openUrl('/intelligent/management')"
            >
              Learn More >
            </button>
          </div>
        </div>
        <div class="jgpt-item">
          <el-row :gutter="18">
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="8"
              :xl="8"
              v-for="(item, index) in jgpt.abilityList"
              :key="index"
            >
              <div
                class="item"
                v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
              >
                <img
                  src="../../../assets/images/intelligentImg/icon-check.png"
                  alt=""
                  srcset=""
                />
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <div v-for="(e, i) in item.description" :key="i">
                    {{ e }}
                  </div>
                  <!-- {{ item.description }} -->
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="module whiteBg">
      <div class="box">
        <div
          class="product zhgd"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <div class="content">
            <div class="title">{{ zhgd.title }}</div>
            <div class="subTitle">{{ zhgd.subTitle }}</div>
            <div class="desc text-wrap">{{ zhgd.description }}</div>
            <button
              class="know-more-btn"
              @click="openUrl('/intelligent/smartSite')"
            >
              Learn More >
            </button>
          </div>
        </div>
        <div class="zhgd-item">
          <el-row>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="8"
              :xl="8"
              v-for="(item, index) in zhgd.sceneList"
              :key="index"
            >
              <div
                class="item cursor-pointer"
                :class="'scene_' + (index + 1)"
                v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
              >
                <!-- <img class="c_img" :src="item.imgUrl" alt="" srcset=""> -->
                <div class="title">{{ item.title }}</div>
                <div class="desc text-wrap">
                  <div
                    class="text-wrap"
                    v-for="(e, i) in item.description"
                    :key="i"
                  >
                    {{ e }}
                  </div>
                  <!-- {{ item.description }} -->
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="module greyBg">
      <div class="box">
        <div
          class="product znlc"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <div class="content">
            <div class="title">{{ znlc.title }}</div>
            <div class="subTitle">{{ znlc.subTitle }}</div>
            <div class="desc text-wrap">{{ znlc.description }}</div>
            <button
              class="know-more-btn"
              @click="openUrl('/intelligent/prefabrication')"
            >
              Learn More >
            </button>
          </div>
        </div>
        <div class="znlc-item">
          <el-row :gutter="18">
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="8"
              :xl="8"
              v-for="(item, index) in znlc.abilityList"
              :key="index"
            >
              <div
                class="item"
                :class="'znlcItem_' + (index + 1)"
                v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
              >
                <div class="title">{{ item.title }}</div>
                <div class="desc text-wrap">{{ item.description }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <ProductGet
      title="Intelligent Construction Product Line"
      subTitle="Used in 40+ major infrastructure projects worldwide!"
      :bgImage="
        require('@/assets/images/intelligentImg/bg-advertising-smartSite.png')
      "
      :downLoadBtn="{
        label: 'Download Brochure',
        show: true,
      }"
    />
  </div>
</template>

<script>
import VerticalBanner from "@/components/VerticalBanner.vue";
import ProductGet from "@/components/ProductGet.vue";
export default {
  data() {
    return {
      // 轮播图
      carouselImgs: [
        {
          id: "1",
          icon: require("@/assets/images/intelligentImg/icon-logo-management.png"),
          title: "Digital Construction Management Platform",
          subTitle:
            "Integrated efficient management.\nEmpowering intelligent construction.\nLeading the industry’s digital transformation.",
          picUrl: require("@/assets/images/intelligentImg/carousel1.png"),
          bannerLink: "/intelligent/management",
        },
        {
          id: "2",
          icon: require("@/assets/images/intelligentImg/icon-logo-smartSite.png"),
          title: "Digital Smart Site Platform",
          subTitle:
            "Driving intelligent, visualized, and efficient site\nmanagement through technological innovation.",
          picUrl: require("@/assets/images/intelligentImg/carousel2.png"),
          bannerLink: "/intelligent/smartSite",
        },
        {
          id: "3",
          icon: require("@/assets/images/intelligentImg/icon-logo-prefabrication.png"),
          title: "Industrialized Prefabrication and Construction Platform",
          subTitle:
            "Achieving standardized production of building components,\nprecise assembly, and full-process digital management.",
          picUrl: require("@/assets/images/intelligentImg/carousel3.png"),
          bannerLink: "/intelligent/prefabrication",
        },
      ],
      // 简介
      blurb: {
        title:
          "Intelligent Construction Product Line – Building the Future of Smart Transportation",
        description:
          "Delauney’s intelligent construction product line leverages cutting-edge technologies, deeply integrating the Internet of Things, big data, cloud computing, 5G, artificial intelligence, and BIM, to create a full-process, intelligent, and high-performance solution for the transportation engineering construction sector.\nFrom the early planning stages of a construction project to precise management during project implementation, and smart optimization during industrial prefabrication production, the solution enables digital upgrades across the entire lifecycle of construction projects. By creating accurate digital twin models, it provides real-time reflections of the project’s actual status, ensuring seamless coordination and precise control over key factors such as progress, quality, and safety.\nThis approach significantly enhances overall construction efficiency and management levels, driving the transformation of the transportation engineering industry from traditional methods to intelligent construction. It opens a new chapter in smart transportation construction, providing robust and reliable technical support to build high-quality, modern transportation infrastructure.",
        img: [
          {
            id: "4",
            url: require("../../../assets/images/intelligentImg/BusinessArea.png"),
          },
        ],
      },
      // 建管平台
      jgpt: {
        title: "Digital Construction Management Platform",
        subTitle:
          "—— Integrated Efficient Management, Empowering Smart Construction",
        description:
          "The Digital Construction Management Platform is a collaborative system for managing transportation construction projects. It focuses on progress, quality, safety, measurement, and documentation, integrating BIM to build a project digital twin and support digital transformation.",
        abilityList: [
          {
            title: "BIM Collaboration",
            description: [
              "BIM Model Displays Data",
              "3D Engineering Management",
            ],
          },
          {
            title: "Schedule Management",
            description: [
              "Project Plan Preparation",
              "Actual Progress Feedback",
            ],
          },
          {
            title: "Quality Management",
            description: ["Process Inspection", "Material Traceability"],
          },
          {
            title: "Safety Management",
            description: ["Risk Control", "Hazard Investigation"],
          },
          {
            title: "Measurement and Payment",
            description: ["Contract Management", "Measurement and Payment"],
          },
          {
            title: "Electronic Record",
            description: ["Quality Information", "Electronic Online Signature"],
          },
        ],
      },
      // 智慧工地
      zhgd: {
        title: "Digital Smart Site Platform",
        subTitle:
          "—— Integrated Efficient Management, Empowering Smart Construction",
        description:
          "The Digital Smart Site Platform leverages IoT, 5G, big data, and BIM to enable visualized, integrated, and collaborative management of key aspects such as quality and safety through refined control of engineering components.",
        sceneList: [
          {
            title: "BIM - Building Information Modeling",
            description: [
              "High precision 3D model",
              "Integrated information management",
            ],
          },
          {
            title: "Internet of Things (IoT)",
            description: ["Accurately control \nthe construction site"],
          },
          {
            title: "Big Data",
            description: [
              "Big data analysis platform",
              "Drive engineering construction",
            ],
          },
          {
            title: "5G Technology",
            description: [
              "Intelligent terminal equipment",
              "Intelligent construction system",
            ],
          },
          {
            title: "Artificial Intelligence",
            description: ["Building an intelligent \ncontrol network"],
            // imgUrl: require("../../../assets/images/intelligentImg/bg-zhgd-scene-5-defalut.png"),
          },
          {
            title: "Laser Point Cloud",
            description: ["High precision, \n3D data acquisition"],
          },
        ],
      },
      // 智能梁场
      znlc: {
        title: "Industrialized Prefabrication and Construction Platform ",
        subTitle:
          "—— Standardized Production, Precise Assembly, and Full-Process Digital Management",
        description:
          'The Industrialized Prefabrication and Construction Platform follows the ISA95 MES standard and integrates big data, cloud computing, 5G, IoT, AI, and BIM to optimize factory scheduling, enhance efficiency, improve quality, and shorten cycles, achieving smart management and intelligent control for a "transparent factory."',
        abilityList: [
          {
            title: "Flexible Scheduling",
            description: "Use of big data for refined production scheduling",
          },
          {
            title: "Visualized Management",
            description: "Multi-style visual decision-making reports",
          },
          {
            title: "Smart Warehousing",
            description:
              "Inventory management with first-in,\nfirst-out principles",
          },
          {
            title: "Full-Process Traceability",
            description: "One item, one code, full traceability",
          },
          {
            title: "Transparent Production",
            description:
              "Error-proofing processes through  operational instructions",
          },
          {
            title: "Efficient Equipment",
            description: "Equipment ledger management and OEE",
          },
        ],
      },
    };
  },
  components: { VerticalBanner, ProductGet },
  methods: {
    // 页面路由跳转
    openUrl(path) {
      console.log("openUrl", path);
      this.$uniFun.openInCurrentTab(path);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.intelligent-container {
  .c_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .module {
    padding: 80px 0;
    .box {
      width: 1200px;
      margin: 0 auto;
    }
    .blurb-title {
      font-size: 24px;
      line-height: 24px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 40px;
      text-align: center;
    }
    .blurb-desc {
      font-size: 18px;
      line-height: 40px;
      color: #333333;
      margin-bottom: 40px;
    }
    .product {
      padding: 58px 0 0 60px;
      margin-bottom: 2px;
      .title {
        width: 1000px;
        font-size: 32px;
        line-height: 48px;
        color: #ffffff;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .subTitle {
        width: 1000px;
        font-size: 24px;
        line-height: 36px;
        color: #ffffff;
        margin-bottom: 24px;
      }
      .desc {
        width: 600px;
        font-size: 18px;
        line-height: 28px;
        color: #ffffff;
        margin-bottom: 40px;
      }
      .know-more-btn {
        padding: 8px 24px;
        background-color: #ffffff;
        color: #1d1d1f;
        border: 1px solid #ffffff;
        border-radius: 20px;
        cursor: pointer;
        font-size: 13px;
        align-self: flex-start; /* 按钮靠左 */
        transition: background-color 0.3s ease, color 0.3s ease;
        z-index: 20;
        &:hover {
          border: 1px solid #0035fb;
          color: #0035fb; /* 或者卡片的主题色 */
        }
      }
      &.selected {
        flex: 1.8;
        .card-content {
          .products {
            display: block;
          }
          .title {
            font-size: 24px;
          }
        }
      }
    }
    .jgpt {
      width: 100%;
      height: 480px;
      background-image: url("../../../assets/images/intelligentImg/bg-jgpt.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }

    .jgpt-item {
      .item {
        width: 100%;
        height: 140px;
        background: #ffffff;
        margin-top: 22px;
        padding: 24px 0 0 76px;
        position: relative;
        opacity: 0;
        img {
          width: 24px;
          height: 24px;
          position: absolute;
          top: 24px;
          left: 24px;
        }
        .title {
          font-size: 20px;
          line-height: 30px;
          color: #1d1d1f;
          font-weight: bold;
          margin-bottom: 6px;
        }
        .desc {
          font-size: 18px;
          line-height: 32px;
          color: #666666;
          > div::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 4px;
            background: #666666;
            border-radius: 50%;
            opacity: 0.8;
            margin-bottom: 5px;
            margin-right: 4px;
          }
        }
      }
    }
    .zhgd {
      width: 100%;
      height: 480px;
      background-image: url("../../../assets/images/intelligentImg/bg-zhgd.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
    .zhgd-item {
      margin-top: 22px;
      .item {
        width: 100%;
        height: 200px;
        padding: 32px 0 0 24px;
        transition: all 0.5s ease-in-out;
        .title {
          font-weight: bold;
          font-size: 18px;
          color: #1d1d1f;
          line-height: 27px;
          text-align: left;
          margin-bottom: 10px;
          transition: all 0.5s ease-in-out;
        }
        .desc {
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          line-height: 24px;
          text-align: left;
          transition: all 0.5s ease-in-out;
          > div::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 4px;
            background: #999999;
            border-radius: 50%;
            opacity: 0.8;
            margin-bottom: 5px;
            margin-right: 4px;
          }
        }
      }
      .scene_1 {
        background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-1-defalut.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        &:hover {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-1-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
        &.active {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-1-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
      }
      .scene_2 {
        background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-2-defalut.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        &:hover {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-2-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
        &.active {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-2-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
      }
      .scene_3 {
        background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-3-defalut.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        &:hover {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-3-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
        &.active {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-3-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
      }
      .scene_4 {
        background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-4-defalut.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        &:hover {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-4-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
        &.active {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-4-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
      }
      .scene_5 {
        background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-5-defalut.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        &:hover {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-5-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
        &.active {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-5-current.png");
          transition: all 0.5s ease-in-out;
        }
      }
      .scene_6 {
        background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-6-defalut.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        &:hover {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-6-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
        &.active {
          background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-6-current.png");
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
      }
    }
    .znlc {
      width: 100%;
      height: 480px;
      background-image: url("../../../assets/images/intelligentImg/bg-znlc.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
    .znlc-item {
      .item {
        width: 100%;
        height: 240px;
        background: #ffffff;
        margin-top: 22px;
        position: relative;
        .title {
          width: 240px;
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          line-height: 30px;
          text-align: left;
          position: absolute;
          top: 160px;
          left: 28px;
        }
        .desc {
          width: 330px;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 18px;
          text-align: left;
          position: absolute;
          top: 196px;
          left: 28px;
        }
      }
      .znlcItem_1 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-1.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_2 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-2.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_3 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-3.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_4 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-4.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_5 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-5.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_6 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-6.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
    }
  }

  .whiteBg {
    background: #ffffff;
  }
  .greyBg {
    background: #f4f8fb;
  }
}
</style>
